function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "8690B0EB-EF9F-479B-881B-DCB44248EBBA@3x");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  opacity: 0.45
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon-Set",
  transform: "translate(-306.000000, -158.000000)",
  fillRule: "nonzero",
  stroke: "#000000"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-5",
  transform: "translate(306.000000, 158.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 0.5,
  y: 0.5,
  width: 19,
  height: 14
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.5,1 L6.5,13.9230769",
  id: "Line-3",
  strokeLinecap: "square"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.5917969,7.92307692 L0.5,7.92307692",
  id: "Line-3-Copy-2",
  strokeLinecap: "square"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.5,1 L13.5,13.9230769",
  id: "Line-3-Copy",
  strokeLinecap: "square"
}))));

var SvgTable = function SvgTable(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "15px",
    viewBox: "0 0 20 15",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTable, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/table.03a77925.svg";
export { ForwardRef as ReactComponent };